jQuery(document).ready(function() {

    //Burger menu animation and side menu on responsive 
    $(".burger-menu").on('click', function(){
        var obj = $(this);

        if(obj.hasClass("active")){
            closeNav();
        }else{
            openNav();    
        }
        burgerAnim(obj);
    });

    $(".closebtn").on('click', function(){
        $( ".mobile-nav" ).trigger( "click" );
    });

    function burgerAnim(x) {
        x.toggleClass("active");  
    }

    function openNav() {
        $("#mySidenav").css("top", "0");
        $(".sidenav-wrapper").css("top", "0");
        $("body").addClass("scroll-past");
    }

    function closeNav() {
        $("#mySidenav").css("top", "-1000px");
        $(".sidenav-wrapper").css("top", "-1000px");
        $("body").removeClass("scroll-past");
    }
    //End of "Burger menu animation and side menu on responsive"

    //slick nav for tabs ... intialize script 
    if($(".slider-nav").length){
    	
    	$('.slider-for').slick({
	        slidesToShow: 1,
	        slidesToScroll: 1,
	        arrows: false,
	        fade: true,
            adaptiveHeight: true,
	        asNavFor: '.slider-nav',
            swipe: false, 

            responsive: [

                {
                  breakpoint: 1024,
                  settings: {
                    fade: false,
                  }
                },

                // You can unslick at a given breakpoint now by adding:
                // settings: "unslick"
                // instead of a settings object
            ]
      	});

      	$('.slider-nav').slick({
	        slidesToShow: 6,
	        slidesToScroll: 1,
	        asNavFor: '.slider-for',
	        arrows: false,
	        centerMode: false,
	        focusOnSelect: true,
            variableWidth: true,


            responsive: [

                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 3,
                    variableWidth: false,
                    centerMode: true,
                    fade: false,
                    infinite: false
                  }
                },

                // You can unslick at a given breakpoint now by adding:
                // settings: "unslick"
                // instead of a settings object
            ]

      	});

    }

    $('[data-toggle="tooltip"]').tooltip({ container: 'body', trigger: 'hover' });
    
    //End of "slick nav for tabs"


});